import { DeepReadonly } from 'helpers/immutable';
import { enTypeUser } from 'interfaces/user';
import { IUserToken } from 'interfaces/userToken';
import * as rxjs from 'rxjs';
import rxjsOperators from 'rxjs-operators';

import tokenService, { TokenService } from './token';
import { IPermissions } from 'interfaces/IPermissions';
import { LOGGED_USER_ACCOUNT_ID } from './login';
import { ACCOUNT_ENV } from 'settings';
import { cookieService, CookieService } from './cookieService';

export class AuthService {
  private user$: rxjs.Observable<DeepReadonly<IUserToken>>;
  private typeUser$: rxjs.BehaviorSubject<number>;
  private userPhoto$: rxjs.BehaviorSubject<string> = new rxjs.BehaviorSubject('');
  private isClubeBlack$: rxjs.BehaviorSubject<boolean> = new rxjs.BehaviorSubject(false);

  constructor(private tokenService: TokenService, private cookieService: CookieService) {
    this.typeUser$ = new rxjs.BehaviorSubject(0);

    this.user$ = this.tokenService.getAccessToken().pipe(
      rxjsOperators.map(token => {
        if (!token) {
          console.log('token not found');
          return null;
        }

        const user = this.tokenService.decode<IUserToken>(token);

        if (!user) {
          console.log('invalid token user');
          return null;
        }

        this.setClubeBlack(user.isClubeBlack);

        return user;
      }),
      rxjsOperators.catchError(() => {
        console.log('failed to observe user');
        return rxjs.of(null);
      })
    );
  }

  public logout() {
    window.history.pushState(null, 'Checkout Sun | Admin', window.location.pathname);
    this.tokenService.clearToken();

    this.cookieService.removeCookie(LOGGED_USER_ACCOUNT_ID);
    this.cookieService.removeCookie('isRedirected');
    window.Eduzz.Accounts.logout({ env: ACCOUNT_ENV });
  }

  public getUser(): rxjs.Observable<DeepReadonly<IUserToken>> {
    return this.user$;
  }

  public setUserPhoto(photo: string) {
    return this.userPhoto$.next(photo);
  }

  public getUserPhoto() {
    return this.userPhoto$.asObservable();
  }

  public isClubeBlack() {
    return this.isClubeBlack$.asObservable();
  }

  public isAuthenticated(): rxjs.Observable<boolean> {
    return this.tokenService.getAccessToken().pipe(rxjsOperators.map(token => !!token));
  }

  public getTypeUser() {
    return this.typeUser$.asObservable();
  }

  public setTypeUser(typeUser: enTypeUser) {
    return this.typeUser$.next(typeUser);
  }

  public getPermissions(): rxjs.Observable<IPermissions> {
    return rxjs.of({
      exitPopUp: {
        canAccess: false
      },
      myProducts: {
        canAccess: true,
        canVinculate: false
      },
      toast: {
        canAccess: false
      },
      scriptsAndChats: {
        canAccess: false
      }
    });
  }

  private setClubeBlack(isClubeBlack: boolean) {
    return this.isClubeBlack$.next(isClubeBlack);
  }
}

const authService = new AuthService(tokenService, cookieService);
export default authService;
